export const LINK_TO = Object.freeze({
  LOG_EXPLORER: 'LOG_EXPLORER',
  SESSION_REPLAYS: 'SESSION_REPLAYS',
  LIVE_TAIL: 'LIVE_TAIL'
})

export function formatRUMLinkString(query, hoursBefore, hoursAfter) {
  return `https://app.datadoghq.com/rum/sessions?query=${formatQueryString(query)}&${formatErrorTimeInterval(hoursBefore, hoursAfter)}`
}

export function formatQueryLinkString(query, hoursBefore, hoursAfter) {
  return `https://app.datadoghq.com/logs?query=${formatQueryString(query)}&${formatErrorTimeInterval(hoursBefore, hoursAfter)}`
}

export function formatQueryExternalLink({
  query,
  linkTo = LINK_TO.LOG_EXPLORER,
  creationDate = null
}) {
  let baseUrl = `https://app.datadoghq.com/`
  if (linkTo === LINK_TO.LOG_EXPLORER) {
    baseUrl += 'logs'
  } else if (linkTo === LINK_TO.LIVE_TAIL) {
    baseUrl += 'logs/livetail'
  } else if (linkTo === LINK_TO.SESSION_REPLAYS) {
    baseUrl += 'rum/sessions'
  }
  return `${baseUrl}?query=${formatQueryString(query)}&${formatOperationTimeInterval(creationDate)}`
}

function formatErrorTimeInterval(hoursBefore, hoursAfter) {
  const hourBeforeEPOC = Date.now() - 3600 * 1000 * hoursBefore
  const hourAfterEPOC = Date.now() + 3600 * 1000 * hoursAfter
  return `from_ts=${hourBeforeEPOC}&to_ts=${hourAfterEPOC}&live=false`
}

function formatOperationTimeInterval(creationDate) {
  if (creationDate == null) {
    return `viz=stream&live=true`
  }
  const opCreationRpoch = Date.parse(creationDate)
  return `from_ts=${opCreationRpoch}&to_ts=${Date.now()}&live=false`
}

function formatQueryString(str) {
  const default_replacements = [
    ['(', '%28'],
    [')', '%29'],
    ['@', '%40'],
    [':', '%3A'],
    ['*', '%2A'],
    [' ', '%20']
  ]
  let out = str.replace(/:\s+/g, ':')
  for (const [from, to] of default_replacements) {
    out = out.split(from).join(to)
  }
  return out
}
